// axiosConfig.ts
import axios, { AxiosInstance, AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios';
import localStorageService from '../services/LocalStorageService';
import { showAlert as showGlobalAlert } from '../store/actions/alertActions';

export const createAxiosInstance = (): AxiosInstance => {
  const axiosInstance: AxiosInstance = axios.create({
    transformResponse: [data => data],
  });

  // Request interceptor to set the token header dynamically
  axiosInstance.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const token = localStorageService.getAccessToken();
      if (token && config.headers) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    error => Promise.reject(error)
  );

  // Response interceptor with custom 401 handling for 'execute' endpoints
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        const url = error.config?.url || '';
        if (url.includes('Execute')) {
          // Dispatch a custom event for non-blocking notification (e.g., toast/snackbar)
          window.dispatchEvent(new CustomEvent('show-toast', { detail: { message: 'Unauthorized', type: 'error' } }));
        } else {
          localStorageService.clearToken();
          if (
            window?.location?.pathname?.startsWith('/app') ||
            window?.location?.pathname?.startsWith('/employee')
          ) {
            window.location.href = '/';
          }
        }
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};
